<rid-flash-counting (finished)="$router.navigate(['/mechanics/formule'])" [numbers]="numbers()" class="h-dvh" />
